var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReservation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.41675 8H8.25008V9.83333H6.41675V8ZM6.41675 11.6667H8.25008V13.5H6.41675V11.6667ZM10.0834 8H11.9167V9.83333H10.0834V8ZM10.0834 11.6667H11.9167V13.5H10.0834V11.6667ZM13.7501 8H15.5834V9.83333H13.7501V8ZM13.7501 11.6667H15.5834V13.5H13.7501V11.6667Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58333 20.1654H17.4167C18.4278 20.1654 19.25 19.3431 19.25 18.332V5.4987C19.25 4.48761 18.4278 3.66536 17.4167 3.66536H15.5833V1.83203H13.75V3.66536H8.25V1.83203H6.41667V3.66536H4.58333C3.57225 3.66536 2.75 4.48761 2.75 5.4987V18.332C2.75 19.3431 3.57225 20.1654 4.58333 20.1654ZM17.4167 7.33203L17.4176 18.332H4.58333V7.33203H17.4167Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReservation);
export default __webpack_public_path__ + "static/media/reservation.a2e1911cb7346b0357c9c5637c9a382c.svg";
export { ForwardRef as ReactComponent };